function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b6d1ca26-c8c1-4801-9637-aab1b6391856,.b77f433e-76d7-426f-a624-942fa085acb3{fill:none;}.a9475af9-29cc-4ac4-95e7-d079f0818053{clip-path:url(#a5c20392-0e58-4e6c-9f91-c4f093f497ab);}.b6d1ca26-c8c1-4801-9637-aab1b6391856{stroke:#e5e4e4;stroke-width:4.14px;}.f46af1dc-8be8-426b-b843-5ee0ff797439{font-size:38.21px;}.a5e47f7e-2129-482f-9db8-0d7b22822933,.a5fb7361-4b40-4868-b6e6-334bfee1753d,.bbeaba12-2cdd-4a02-89c6-47b136cde114,.bc4af33d-cb7c-401c-a248-af2a580e4eda,.e0d03c3a-5104-43f7-948c-7c7b12b03044,.f46af1dc-8be8-426b-b843-5ee0ff797439,.fa817255-2f8e-4aa7-8167-db29b733930d{fill:#e5e4e4;font-family:futura-pt, sans-serif;}.fa817255-2f8e-4aa7-8167-db29b733930d{font-size:38.21px;}.a5fb7361-4b40-4868-b6e6-334bfee1753d{font-size:38.21px;}.e0d03c3a-5104-43f7-948c-7c7b12b03044{font-size:38.21px;}.bbeaba12-2cdd-4a02-89c6-47b136cde114{font-size:38.21px;}.bc4af33d-cb7c-401c-a248-af2a580e4eda{font-size:38.21px;}.a5e47f7e-2129-482f-9db8-0d7b22822933{font-size:38.21px;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "a5c20392-0e58-4e6c-9f91-c4f093f497ab"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b77f433e-76d7-426f-a624-942fa085acb3",
  x: 34,
  y: 35,
  width: 432,
  height: 432
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ac5ccff5-0571-476c-a0f6-4d90559adf58",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "b7b9fd25-43c9-490f-91fc-239efe0f6926",
  "data-name": "LogoInner_White"
}, /*#__PURE__*/React.createElement("g", {
  className: "a9475af9-29cc-4ac4-95e7-d079f0818053"
}, /*#__PURE__*/React.createElement("g", {
  className: "a9475af9-29cc-4ac4-95e7-d079f0818053"
}, /*#__PURE__*/React.createElement("circle", {
  className: "b6d1ca26-c8c1-4801-9637-aab1b6391856",
  cx: 250,
  cy: 251,
  r: 169.71,
  transform: "translate(-104.26 250.29) rotate(-45)"
})), /*#__PURE__*/React.createElement("text", {
  className: "f46af1dc-8be8-426b-b843-5ee0ff797439",
  transform: "matrix(-0.57, 0.82, -0.82, -0.57, 124.88, 145.34)"
}, "C"), /*#__PURE__*/React.createElement("text", {
  className: "fa817255-2f8e-4aa7-8167-db29b733930d",
  transform: "translate(108.44 168.54) rotate(114.83)"
}, "O"), /*#__PURE__*/React.createElement("text", {
  className: "a5fb7361-4b40-4868-b6e6-334bfee1753d",
  transform: "translate(95.65 196.29) rotate(104.54)"
}, "D"), /*#__PURE__*/React.createElement("text", {
  className: "e0d03c3a-5104-43f7-948c-7c7b12b03044",
  transform: "translate(88.51 223.86) rotate(94.78)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "a5fb7361-4b40-4868-b6e6-334bfee1753d",
  transform: "translate(86.15 250.17) rotate(85.16)"
}, "R"), /*#__PURE__*/React.createElement("text", {
  className: "a5fb7361-4b40-4868-b6e6-334bfee1753d",
  transform: "translate(89.08 278.82) rotate(77.93)"
}), /*#__PURE__*/React.createElement("text", {
  className: "bbeaba12-2cdd-4a02-89c6-47b136cde114",
  transform: "matrix(0.33, 0.95, -0.95, 0.33, 91.06, 290.61)"
}, "&"), /*#__PURE__*/React.createElement("text", {
  className: "bc4af33d-cb7c-401c-a248-af2a580e4eda",
  transform: "matrix(0.43, 0.9, -0.9, 0.43, 100.11, 315.83)"
}), /*#__PURE__*/React.createElement("text", {
  className: "e0d03c3a-5104-43f7-948c-7c7b12b03044",
  transform: "matrix(0.55, 0.84, -0.84, 0.55, 104.64, 326.82)"
}, "G"), /*#__PURE__*/React.createElement("text", {
  className: "bc4af33d-cb7c-401c-a248-af2a580e4eda",
  transform: "matrix(0.68, 0.73, -0.73, 0.68, 120.95, 351.81)"
}, "A"), /*#__PURE__*/React.createElement("text", {
  className: "bbeaba12-2cdd-4a02-89c6-47b136cde114",
  transform: "matrix(0.8, 0.6, -0.6, 0.8, 138.59, 371.38)"
}, "M"), /*#__PURE__*/React.createElement("text", {
  className: "a5e47f7e-2129-482f-9db8-0d7b22822933",
  transform: "translate(164.85 390.79) rotate(26.53)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "a5e47f7e-2129-482f-9db8-0d7b22822933",
  transform: "matrix(0.94, 0.34, -0.34, 0.94, 188.96, 402.4)"
}), /*#__PURE__*/React.createElement("text", {
  className: "e0d03c3a-5104-43f7-948c-7c7b12b03044",
  transform: "matrix(0.98, 0.22, -0.22, 0.98, 200.01, 406.95)"
}, "D"), /*#__PURE__*/React.createElement("text", {
  className: "e0d03c3a-5104-43f7-948c-7c7b12b03044",
  transform: "translate(227.79 413.25) rotate(3.01)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "f46af1dc-8be8-426b-b843-5ee0ff797439",
  transform: "translate(254.2 414.72) rotate(-6.28)"
}, "S"), /*#__PURE__*/React.createElement("text", {
  className: "fa817255-2f8e-4aa7-8167-db29b733930d",
  transform: "translate(280.74 411.4) rotate(-13.16)"
}, "I"), /*#__PURE__*/React.createElement("text", {
  className: "bc4af33d-cb7c-401c-a248-af2a580e4eda",
  transform: "translate(292.47 409.32) rotate(-20.43)"
}, "G"), /*#__PURE__*/React.createElement("text", {
  className: "a5e47f7e-2129-482f-9db8-0d7b22822933",
  transform: "translate(321.08 398.65) rotate(-30.89)"
}, "N"), /*#__PURE__*/React.createElement("text", {
  className: "bc4af33d-cb7c-401c-a248-af2a580e4eda",
  transform: "matrix(0.76, -0.65, 0.65, 0.76, 345.54, 384.08)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "a5e47f7e-2129-482f-9db8-0d7b22822933",
  transform: "translate(365.67 366.85) rotate(-49.8)"
}, "R"))));
function SvgLogoInnerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInnerWhite);
export default __webpack_public_path__ + "static/media/LogoInnerWhite.4e66dba8.svg";
export { ForwardRef as ReactComponent };